import SegmentContainer from "./SegmentContainer";

export default SegmentContainer;
